<template>
	<div>
		<div class="card">
			<div class="card-body">
				<!-- Settings Menu -->
				<div class="widget settings-menu mb-0">
					<ul>
						<li class="nav-item">
							<router-link
								v-bind:class="{ active: currentPath == 'settings' }"
								to="/settings"
								class="nav-link"
							>
								<i class="far fa-user"></i> <span>Profile Settings</span>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								:class="{ active: currentPath == 'preferences' }"
								to="/preferences"
								class="nav-link"
							>
								<i class="fas fa-cog"></i> <span>Preferences</span>
							</router-link>
						</li>
						<li class="nav-item">
							<a
								@click="goToPayments()"
								:class="{ active: currentPath == 'payments' }"
								class="nav-link"
							>
								<i class="fa fa-credit-card"></i> <span>Payment</span>
								<span
									v-if="user.active_subscription?.plan_id != 4 || user.active_subscription?.plan_id != 5"
									style="height: fit-content"
									class="badge ms-2 bg-info text-center fw-light text-white text-capitalize"
									>Premium</span
								>
							</a>
						</li>
						<li class="nav-item">
							<router-link
								to="/notifications"
								class="nav-link"
								v-bind:class="{ active: currentPath == 'notifications' }"
							>
								<i class="far fa-bell"></i> <span>Notifications</span>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								to="/change-password"
								class="nav-link"
								v-bind:class="{ active: currentPath == 'change-password' }"
							>
								<i class="fas fa-unlock-alt"></i> <span>Change Password</span>
							</router-link>
						</li>
					</ul>
				</div>
				<!-- /Settings Menu -->
			</div>
		</div>
		<h5 class="mb-4">Invoice Settings</h5>
		<div class="card">
			<div class="card-body">
				<!-- Settings Menu -->
				<div class="widget settings-menu mb-0">
					<ul>
						<li class="nav-item">
							<router-link
								v-bind:class="{ active: currentPath == 'invoice-settings' }"
								:to="{ name: 'invoice-settings' }"
								class="nav-link"
							>
								<i class="fas fa-cog"></i> <span>General Settings</span>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								v-bind:class="{
                  active: currentPath == 'invoice-bank-settings',
                }"
								:to="{ name: 'invoice-bank-settings' }"
								class="nav-link"
							>
								<i class="fa fa-university"></i> <span>Bank</span>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								:to="{ name: 'tax-types' }"
								class="nav-link"
								v-bind:class="{ active: currentPath == 'tax-types' }"
							>
								<i class="far fa-check-square"></i> <span>Tax</span>
							</router-link>
						</li>
					</ul>
				</div>
				<!-- /Settings Menu -->
			</div>
		</div>
	</div>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute,useRouter } from "vue-router";

const store = useStore();
const route = useRoute();
const router = useRouter()

const user = computed(() => {
  return store.getters["auth/user"];
});

const currentPath = computed(() => {
  return route.name;
});

const goToPayments = () => {
  if (user.value.active_subscription.plan_id === 4 || user.value.active_subscription.plan_id === 5) {
    router.push('/payments')
  } else {
    router.push('/membership-plans')
  }
}
</script>
